import React from 'react';
import  Class8Fieldtrip2024  from 'views/Class8Fieldtrip2024';

const VissionAndMissionPage = () => {
  return <Class8Fieldtrip2024/>;
};

export default VissionAndMissionPage;
